

export interface BidLoginResult {
	success: boolean;
	token: string;
	//tooYoung:boolean;
	//mustContact:boolean;
}

export interface QrCodeResult {
	data: string;
	success: boolean;
}

export interface BidCheckLoginResult {
	status: string;
	isComplete: boolean;
	isAborted: boolean;
	message: string;
}

export interface ServerSession {
	isLoggedIn: boolean;
	isAdmin: boolean;
	ssn: string;
	firstName: string;
	lastName: string;
}

/*
LHB Bank ID service. Logs in with a SSN and gets a token and user name.
*/
export class BIDLoginService {
	private url: string;

	constructor(url: string) {
		this.url = url;
	}

	// Starts BID login procedure.
	login(ssn: string, device: ('MOBILE' | 'SAME')): Promise<BidLoginResult> {
		return this.bidPost<BidLoginResult>('Login', {
			ssn: ssn,
			device: device
		}).then(result => {
			if (device === "SAME") {
				this.redirectToBankIDApp(result.token)
			}
			return result;
		});
	}

	// Check login status.
	checkLogin(loginToken: string): Promise<BidCheckLoginResult> {
		return this.bidPost<BidCheckLoginResult>('CheckLogin', { token: loginToken });
	}

	collect(startToken: string): Promise<QrCodeResult> {
		return this.bidPost<QrCodeResult>('Collect', { startToken: startToken });
	}

	// DEBUG ONLY.
	// Call server and set all state as logged in.
	fakeLogin(ssn: string, device: string): Promise<BidLoginResult> {
		return this.bidPost<BidLoginResult>('FakeLogin', {
			ssn: ssn,
			device: device
		}).then(result => {
			return result;
		});
	}

	// Log out current session.
	logout(): Promise<any> {
		return this.bidPost<any>('Logout', {
		}).then(result => {
			return result;
		});
	}

	// Get session info from server.
	getSession(): Promise<ServerSession> {
		return this.bidGet<ServerSession>('Session')
			.then(result => {
				return result;
			});
	}

	// ==== TOOLS ======================


	getFakeLogin(ssn: string = "196834108512"): Promise<BidLoginResult> {
		let result = {
			success: true,
			token: "QWERWEQWEQWEQE",
			tooYoung: false,
			mustContact: false
		} as BidLoginResult;
		return Promise.resolve(result);
	}

	static createBankIdAutostartUrl(token: string, returnUrl?: string | null): string {
		// bankid:///?autostarttoken=[TOKEN]&redirect=[RETURNURL]
		// todo Se sida 7 "Launching the BankID app From a Browser"
		// https://www.bankid.com/assets/bankid/rp/bankid-relying-party-guidelines-v3.2.2.pdf
		// verkar som att om man sätter "redirect url" så laddas webbläsaren om, om man sätter NULL så återfår den kallande applikationen fokus

		let url = "bankid:///?autostarttoken=" + encodeURIComponent(token)
		if (returnUrl === null)
			url += "&redirect=null";
		else if (returnUrl)
			url += "&redirect=" + encodeURIComponent(returnUrl);

		return url;
	}

	redirectToBankIDApp(token: string) {
		let returnUrl;
		if (!returnUrl)
			returnUrl = "null"; //document.location.href;

		const url = BIDLoginService.createBankIdAutostartUrl(token, returnUrl);
		document.location.href = url;
	}

	// ==== HTTP CALL ======================

	private bidPost<T>(op: string, body: any): Promise<T> {
		let bodyJson = JSON.stringify(body);
		return fetch(this.url + '/' + op, {
			method: "POST",
			cache: 'no-cache',
			credentials: 'include', //include cookies
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: bodyJson
		})
			.then(result => {
				return result.json();
			})
			.then((result) => {
				let bidResult: T = result;
				return bidResult;
			});
	}


	private bidGet<T>(op: string): Promise<T> {
		return fetch(this.url + '/' + op, {
			method: "GET",
			cache: 'no-cache',
			credentials: 'include', //include cookies
			headers: {
				'Accept': 'application/json'
			},
		})
			.then(result => {
				return result.json();
			})
			.then((result) => {
				let bidResult: T = result;
				return bidResult;
			});
	}

}
